import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getChatDetails,
  getChatList,
  getChatReport,
  getRequests,
  getStories,
} from "store/services/chatReport";

export const GetAllChatList = createAsyncThunk(
  "chatList/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getChatList(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const GetAllChatDetails = createAsyncThunk(
  "chatDetail/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getChatDetails(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const GetAllChatReports = createAsyncThunk(
  "chatReport/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getChatReport(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const GetAllRequests = createAsyncThunk(
  "request/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getRequests(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const GetAllStories = createAsyncThunk(
  "stories/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getStories(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
